import { Component } from "@angular/core";

import { CreateMode, IGridColumn, IGridSettings, ITableSettings, UpdateMode } from "@features/grid";
import { OrganizationService } from "./organization.service";
import {FilterInputType, IFilterSettings, StringFilterMatchMode} from "@features/filter";
import {Router} from "@angular/router";
import { NamingConventionService } from "@mipro/services/naming-convention.service";
import { IGoverningBody } from "@project/governingbody/governingbody";
import { SelectItem } from "primeng/api";
import { GoverningBodyService } from "@project/governingbody/governingbody.service";
import { UserHelperService } from "@main/users/user-helper.service";
import { CoreRole } from "@main/roles";


@Component({
    selector: "companies",
    templateUrl: "./companies.component.html",
    styleUrls: ["./companies.component.scss"]
})
export class CompaniesComponent {
    allGovBodies: IGoverningBody[] = [];
    govBodyOptions: Array<SelectItem> = [];
    tableSettings: ITableSettings = {
        columns: <IGridColumn[]>[
            { field: "name", header: "Name" },
            { field: "description", header: "Description" },
            {
                field: "governingBodyName",
                header: "Governing Body Name",
            },
        ]
    };

    filterSettings: IFilterSettings[];
    filterVisible: boolean = false;

    gridSettings: IGridSettings = {
        createMode: CreateMode.Disabled,
        createLink: "/app/companies/edit/0",
        updateMode: UpdateMode.Redirect,
        updateLink: "/app/companies/edit/:id",
        deletingAvailable: rowData => !(rowData.name == OrganizationService.FunctionalGutOrgName),
        exportEnabled: false
    };

    private async init() : Promise<void> {
        this.gridSettings.dataService = this.companyService;
        this.allGovBodies = await this.governingBodyService.getAllGovBody();

        this.filterSettings = [
            {
                header: "Name",
                valueFieldName: "name",
                matchModeSelectorVisible: false,
                matchMode: StringFilterMatchMode.Contains
            },
            {
                header: "Gov. Body Name",
                valueFieldName: "governingBodyId",
                inputType: FilterInputType.Dropdown,
                dropdownOptions: this.allGovBodies.map(item => <SelectItem>{ label: item.name, value: item.id }),
                autoSubmitSelectableInputChange: true,
                visible: () => !this.userHelperService.hasRole(CoreRole.GovBodyAdmin)
            }
        ];
    }

    constructor(private companyService: OrganizationService,
                private router: Router,
                public namingConvService: NamingConventionService,
                private governingBodyService: GoverningBodyService,
                private userHelperService: UserHelperService) {
        this.init()
    }

    onAddRedirect() {
        this.router.navigate(["/app/companies/edit/0"]);
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }
}